"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.query = void 0;
require("core-js/modules/es6.object.assign");
require("core-js/modules/es6.function.name");
const react_1 = __importDefault(require("react"));
// import Pager from '../components/pager'
const layouts_1 = __importDefault(require("../layouts"));
const PostBanner_1 = __importDefault(require("../components/writing/PostBanner"));
const pager_1 = __importDefault(require("../components/pager"));
exports.query = "2337430446";
var WritingPage = function WritingPage(_ref) {
    var data = _ref.data, pageContext = _ref.pageContext;
    console.log(data, pageContext);
    var writings = data.allAirtable.nodes.map(function (w) {
        return {
            title: w.data.title,
            slug: w.data.slug,
            featured: w.data.featured,
            date: w.data.date,
            excerpt: w.data.text_en ? w.data.text_en.childMarkdownRemark.excerpt : null,
            organisation: (w.data.organisation ? w.data.organisation.map(function (o) {
                return o.data.title;
            }) : [])[0],
            teaser: w.data.attachments && w.data.attachments.localFiles && w.data.attachments.localFiles.map(function (a) {
                return a.childImageSharp.fluid;
            })[0],
            tags: w.data.tags ? w.data.tags.map(function (t) {
                return t.data.name;
            }) : null
        };
    });
    return /*#__PURE__*/ react_1.default.createElement(layouts_1.default, null, /*#__PURE__*/ react_1.default.createElement("div", {
        className: "row"
    }, /*#__PURE__*/ react_1.default.createElement("section", null, /*#__PURE__*/ react_1.default.createElement("h1", null, "Writing"), /*#__PURE__*/ react_1.default.createElement("section", null, /*#__PURE__*/ react_1.default.createElement("div", {
        className: "writings container--small"
    }, writings.map(function (w, i) {
        return /*#__PURE__*/ react_1.default.createElement(PostBanner_1.default, Object.assign({
            key: i + w.title
        }, w));
    }), /*#__PURE__*/ react_1.default.createElement(pager_1.default, {
        pageContext: pageContext
    }))))));
};
exports.default = WritingPage;
